import hasPresentValue from './has-present-value'

const isMissingNumberOfStudentsEnrolled = (courses) => {
  return !courses.every((course) => hasPresentValue(course.enrollment))
}
export default isMissingNumberOfStudentsEnrolled
